module.exports = function view (state, actions) {
  return h('div', {}, state.user ? h('div', { key: (state.user.id.value), class: 'card' }, h('div', { class: 'card-content' }, [
    h('div', { class: 'media' }, [
      h('div', { class: 'media-left' }, h('figure', { class: 'image is-48x48' }, h('x-profile-image', { size: 'thumbnail', url: (state.user.picture.large) }))),
      h('div', { class: 'media-content' }, [
        h('p', { class: 'title is-4' }, (state.user.name.title) + '\
            ' + (state.user.name.first) + '\
            ' + (state.user.name.last)),
        h('p', { class: 'subtitle is-6' }, [
          h('x-profile-nationality', { code: (state.user.nat) }),
          (state.user.id.name)
        ])
      ])
    ]),
    h('div', { class: 'content' }, [
      h('div', {}, [
        h('span', { class: 'icon has-text-success' }, h('i', { class: 'fa fa-phone' })),
        h('a', { href: 'tel:' + (state.user.phone) }, (state.user.phone))
      ]),
      h('div', {}, [
        h('span', { class: 'icon has-text-info' }, h('i', { class: 'fa fa-birthday-cake' })),
        h('time', { datetime: (state.user.registered) }, (new Date(state.user.dob).toDateString()))
      ]),
      h('div', {}, [
        h('span', { class: 'icon has-text-warning' }, h('i', { class: 'fa fa-envelope' })),
        h('a', { href: 'mailto:' + (state.user.email) }, (state.user.email))
      ])
    ])
  ])) : undefined)
}
